import { GET_RECENT_SEARCHES, GET_RECENT_SEARCHES_EMPTY, GET_RECENT_SEARCHES_ERROR, GET_RECENT_SEARCHES_SUCCESS } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetRecentSearches = (state = initialState, action) => {
  switch (action.type) {
    case GET_RECENT_SEARCHES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_RECENT_SEARCHES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_RECENT_SEARCHES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_RECENT_SEARCHES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetRecentSearches;
